export default "__VITE_ASSET__BhFJpQmF__"